import { StoreId as StoreId } from "../decorators/StoreIdDecorator";
import API from "./API";

type RoleData = {
  id: number;
  name: string;
  roleManagement?: boolean;
  batchClassMigration?: boolean;
  auditTrail?: boolean;
  viewReports?: boolean;
};

export default class Role {
  @StoreId
  id: number;
  name: string;

  /*
   * A Read only value provided by the API to indicate if Role Permissions screen can be seen.
   */
  readonly roleManagement: boolean = false;
  readonly batchClassMigration: boolean = false;
  readonly auditTrail: boolean = false;
  readonly viewReports: boolean = false;

  constructor(data: RoleData) {
    this.id = data.id;
    this.name = data.name;
    this.roleManagement = data.roleManagement ?? false;
    this.batchClassMigration = data.batchClassMigration ?? false;
    this.auditTrail = data.auditTrail ?? false;
    this.viewReports = data.viewReports ?? false;
  }

  changeRolePropertyValue(propertyName: string, value: any) {
    //@ts-expect-error
    this[propertyName] = value;
  }

  getRolePropertyValue(propertyName: string): any {
    //@ts-expect-error
    return this[propertyName];
  }

  getSaveModel(): SaveRole {
    return new SaveRole(this);
  }
}

class SaveRole {
  id: number;
  name: string;
  constructor(role: Role) {
    this.id = role.id;
    this.name = role.name;
  }

  // note for tomorrow morning: the SaveRole class is unnecessary because we do not update Role's,
  // but useful when keeping in mind how the BatchClassRoleViewModel will work within the RoleStore
  async save(): Promise<boolean> {
    return await API.patch(`/v0/role/${this.id}`, null, this)
      .then((value: Response) => value.text())
      .then((value: string) => value === "true")
      .catch(() => {
        return false;
      });
  }
}
export { RoleData, SaveRole };
